import React from 'react';
import { Link } from 'react-router-dom';
import { SparklesIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <Link to="/home" className="flex items-center space-x-2">
                <SparklesIcon className="w-8 h-8 text-blue-600" />
                <span className="text-2xl font-bold text-gray-900">Smartera</span>
              </Link>
            </div>
            
            <div className="flex items-center space-x-4">
              <Link to="/home" className="text-gray-700 hover:text-blue-600 transition-colors">Trang chủ</Link>
              <Link to="/contact" className="text-gray-700 hover:text-blue-600 transition-colors">Liên hệ</Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <Link 
            to="/register" 
            className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-4"
          >
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            Quay lại đăng ký
          </Link>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Điều khoản sử dụng</h1>
          <p className="text-gray-600">Cập nhật lần cuối: 05/07/2025</p>
        </div>

        {/* Content */}
        <div className="prose prose-blue max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Chấp nhận điều khoản</h2>
            <p className="text-gray-700 mb-4">
              Bằng việc truy cập và sử dụng dịch vụ của Smartera, bạn đồng ý tuân thủ và bị ràng buộc bởi 
              các điều khoản và điều kiện được nêu trong tài liệu này.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Mô tả dịch vụ</h2>
            <p className="text-gray-700 mb-4">
              Smartera cung cấp các dịch vụ phát triển website, ứng dụng mobile, digital marketing, 
              hosting và tư vấn công nghệ thông tin cho doanh nghiệp.
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Thiết kế và phát triển website</li>
              <li>Phát triển ứng dụng mobile iOS/Android</li>
              <li>Dịch vụ digital marketing và SEO</li>
              <li>Hosting, domain và dịch vụ cloud</li>
              <li>Tư vấn chuyển đổi số</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Quyền và nghĩa vụ của khách hàng</h2>
            <div className="mb-4">
              <h3 className="text-lg font-medium text-gray-900 mb-2">Quyền của khách hàng:</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Được cung cấp dịch vụ đúng cam kết</li>
                <li>Được hỗ trợ kỹ thuật trong thời gian bảo hành</li>
                <li>Được bảo mật thông tin cá nhân</li>
                <li>Được thông báo về các thay đổi dịch vụ</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">Nghĩa vụ của khách hàng:</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Thanh toán đúng hạn theo hợp đồng</li>
                <li>Cung cấp thông tin chính xác và đầy đủ</li>
                <li>Không sử dụng dịch vụ cho mục đích bất hợp pháp</li>
                <li>Tuân thủ các quy định về bảo mật</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Thanh toán và hoàn tiền</h2>
            <p className="text-gray-700 mb-4">
              Khách hàng có thể thanh toán qua các phương thức: chuyển khoản ngân hàng, 
              thẻ tín dụng, hoặc các phương thức thanh toán điện tử khác được chấp nhận.
            </p>
            <p className="text-gray-700 mb-4">
              Chính sách hoàn tiền sẽ được áp dụng theo từng loại dịch vụ cụ thể và 
              được quy định rõ trong hợp đồng dịch vụ.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Bảo mật và quyền riêng tư</h2>
            <p className="text-gray-700 mb-4">
              Smartera cam kết bảo vệ thông tin cá nhân của khách hàng theo 
              <Link to="/privacy" className="text-blue-600 hover:text-blue-700">
                Chính sách bảo mật
              </Link> của chúng tôi.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Giới hạn trách nhiệm</h2>
            <p className="text-gray-700 mb-4">
              Smartera không chịu trách nhiệm về các thiệt hại gián tiếp, ngẫu nhiên, 
              đặc biệt hoặc do hậu quả phát sinh từ việc sử dụng dịch vụ.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Sửa đổi điều khoản</h2>
            <p className="text-gray-700 mb-4">
              Smartera có quyền sửa đổi các điều khoản này bất cứ lúc nào. 
              Các thay đổi sẽ có hiệu lực ngay khi được đăng tải trên website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Liên hệ</h2>
            <p className="text-gray-700 mb-4">
              Nếu bạn có bất kỳ câu hỏi nào về các điều khoản này, vui lòng liên hệ:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700"><strong>Email:</strong> legal@smartera.uk</p>
              <p className="text-gray-700"><strong>Điện thoại:</strong> +44 7537 120666</p>
              <p className="text-gray-700"><strong>Địa chỉ:</strong> London, United Kingdom</p>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 pt-8 mt-12">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-600 text-sm mb-4 sm:mb-0">
              © 2025 Smartera. All rights reserved.
            </p>
            <div className="flex space-x-4 text-sm">
              <Link to="/privacy" className="text-blue-600 hover:text-blue-700">
                Chính sách bảo mật
              </Link>
              <Link to="/contact" className="text-blue-600 hover:text-blue-700">
                Liên hệ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
